import { useState, useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, StickyPriceBar, DeviceImages, ConfirmModal } from 'mobily-ui-library';

import { GlobalContext } from '../../../context/GlobalContext';
import { graphqlApi, createShoppingcart, promotionQualification, applyPromotion } from '../../../api/api';

import ErrorModal from '../../ErrorModal/ErrorModal';
import ProductVariants from '../ProductVariants/ProductVariants';
import ProductFinance from '../ProductFinance/ProductFinance';
import AppleCare from '../AppleCare/AppleCare';
import NotifyMe from '../../NotifyMe/NotifyMe';

import { setCookie, checkCookie, useScroll } from '../../../Utils';

import { handleApiError } from '../../../functions/handleApiError';

import { PROD } from '../../../Constants';

import TamarabadgeEN from "../../../assets/TamarabadgeEN.svg";
import TamarabadgeAR from "../../../assets/TamarabadgeAR.jpg";
import CircleArrowRight from '../../../assets/CircleArrowRight.svg';
import tradeinOrg from '../../../assets/tradeinOrg.svg';
import './ProductDetails.scss';

const win: any = window;
const serverURL = win['base_portal_url'];
const cartPage = win['cart_app_url'];
win.dataLayer = win.dataLayer || [];

interface Props {
    hits: any;
    currentTime: number;
}

const getRemainingTime = (
  endDate: string,
  currentTime: number
) => {
  const diff = new Date(endDate).getTime() - currentTime;

  if (diff <= 0) return "";

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return `${hours}h : ${minutes}m : ${seconds}s`;
};

const retryCount = win['AllowedAPIRetryCount'] ? win['AllowedAPIRetryCount'] : 4;
let createshoppingcartCounter = 0;

function ProductDetails({ hits, currentTime }: Props) {
    const modalRef: any = useRef("");
    const { scrollY } = useScroll();

    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, xCoId, seriesId, deviceTradeLink, lang, subPageToDisplay: stepName, journeyName, orderType, homePageUrl } = state;

    const [soldOut, setSoldOut] = useState(false);
    const [outOfStock, setOutOfStock] = useState(false);
    const [notifyMeFlow, setNotifyMeFlow] = useState(false);
    const [cartFull, setCartFull] = useState(false);
    const [preOrder, setPreOrder] = useState(false);
    const [backOrder, setBackOrder] = useState(false);
    const [eligibleTamara, setEligibleTamara] = useState(false);
    const [stockStatus, setStockStatus] = useState(false);
    const [missingVariant, setMissingVariant] = useState(false);
    const [isTooltipVisible, setTooltipVisibility] = useState(false);
    const [modalVisable, setModalVisable] = useState<any>(false);
    const [imgZoomIn, setImgZoomIn] = useState<any>(false);
    const [initialPrice, setInitialPrice] = useState<any>(true);
    const [throttleFlag, setThrottleFlag] = useState<any>(false);
    const [subsidyFlow, setSubsidyFlow] = useState<string>('');
    const [availabilityMsg, setAvailabilityMsg] = useState<string>('');
    const [availabilityFlag, setAvailabilityFlag] = useState<any>(false);
    const [appleCareBanner, setAppleCareBanner] = useState(false);
    const [isAppleDevice, setIsAppleDevice] = useState(false);

    const [preOrderDate, setPreOrderDate] = useState('');
    const [backOrderDate, setBackOrderDate] = useState('');
    const [price, setPrice] = useState('');
    const [productID, setProductID] = useState('');

    const [filters, setFilters] = useState<any>({});
    const [attributes, setAttributes] = useState<any>([]);
    const [isVariantError, setIsVariantError] = useState<any>(false);
    const [productVariationData, setProductVariationData] = useState<any>([]);
    const [enabledAttributeOptions, setEnabledAttributeOptions] = useState({});

    const [productVariants, setProductVariants] = useState<any>([]);
    const [productCategory, setProductCategory] = useState<any>({});
    const [deviceImages, setDeviceImages] = useState<any>([]);
    const [matchedProduct, setMatchedProduct] = useState<any>({});
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

    const [poid, setPoid] = useState('');
    const [transId, setTransId] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [veriantId, setVeriantId] = useState(null);
    const [skuId, setSkuId] = useState(null);

    const [errorTitle, setErrorTitle] = useState('');
    const [errorModal, setErrorModal] = useState(false)
    const [isServiceError, setIsServiceError] = useState(false)
    const [tradeInEnabled] = useState(win['trade_in_enabled'])
    const [promotion, setPromotion] = useState({
      promotionDiscountedPrice: 0,
      promotionDiscountedPriceWithoutVAT: 0,
      promotionEndDate: '',
      promotionStartDate: '',
      promotionStatus: 'Inactive',
      promotionTextAr: '',
      promotionTextEn: '',
      promotionTimer: false,
    })
const updatePromotionData = (data: {  promotionDiscountedPrice: any; promotionDiscountedPriceWithoutVAT: any; promotionEndDate: any; promotionStartDate: any; promotionStatus: any; promotionTextAr: any; promotionTextEn: any; promotionTimer: any; }) => {
  setPromotion(prev => ({
    ...prev,
    ...data,
  }));
};
    useEffect(() => {
        if (hits.length > 0) {
            // const defaultVariantDetails = hits.filter((item: any) => item.isDefault)
            // const defaultVariant = defaultVariantDetails.length ? defaultVariantDetails[0] : hits[0]
            const defaultVariant = hits[0];
            const productCategory = defaultVariant.category;
            const variantAttributes = productCategory?.variantAttributes;
            setPoid(productCategory?.name?.valueEn); // app dynamic
            setIsAppleDevice(productCategory?.brand?.code === 'Apple' && productCategory?.deviceType?.code === 'Handset');

            const attributes = Object.keys(productCategory)
                .filter((key) => variantAttributes.includes(key))
                .map((el, i) => {
                    if (el.toLowerCase().includes('color')) {
                        return {
                            id: i + 1,
                            name: el,
                            options: productCategory[el].map((item: any) => rtl ? item.valueAr : item.valueEn),
                            hex_options: productCategory[el].map((item: any) => item.code)
                        };
                    } else {
                        return {
                            id: i + 1,
                            name: el,
                            options: productCategory[el].map((item: any) => rtl ? item.valueAr : item.valueEn)
                        };
                    }
                }).filter((item: any) => item.options.length > 0 && item.options.some((op: any) => op != null))

            const productVariationStock = hits.filter((va: any) => va.stockStatus.code === 'In Stock');
            const productVariationData = productVariationStock.map((item: any) => {
                const newAttr = Object.keys(item)
                    .filter((key) => variantAttributes.includes(key))
                    .map((el, i) => {
                        if (el.toLowerCase().includes('color')) {
                            return {
                                id: i + 1,
                                name: el,
                                option: rtl ? item[el].valueAr : item[el].valueEn,
                                hex_option: item[el]?.code
                            };
                        } else {
                            return {
                                id: i + 1,
                                name: el,
                                option: rtl ? item[el].valueAr : item[el].valueEn
                            };
                        }
                    });

                return { ...item, attributes: newAttr };
            });

            setAttributes(attributes);
            setProductVariationData(productVariationData);

            let enabledAttributes: any = [];
            let newFilters: any = {};
            attributes.map((attribute) => {
                enabledAttributes[attribute.name] = attribute.options;
                newFilters[attribute.name] = "";
                return null;
            });

            setFilters(newFilters);
            setEnabledAttributeOptions(enabledAttributes);

            setProductVariants(hits);
            setProductCategory(productCategory);

            const stock = hits.some((hit: any) => hit.stockStatus.code === "In Stock");
            setSoldOut(!stock);

            const preOrder = defaultVariant.preOrder;
            console.log("defaultVariant", defaultVariant)
            setPreOrder(preOrder);

            setBackOrder(defaultVariant?.backOrder);
            setEligibleTamara(defaultVariant.eligibleForTamara)
            setAppleCareBanner(defaultVariant?.appleCareEnabled);

            let preOrderDate = defaultVariant.preOrderDeliveryDate;
            const [yyyy, mm, dd] = preOrderDate.split(/-/g);
            preOrderDate = `${dd}/${mm}/${yyyy}`;
            setPreOrderDate(preOrderDate)

            let backorderDate = defaultVariant?.backOrderDeliveryDate;
            const [byyyy, bmm, bdd] = backorderDate ? backorderDate.split(/-/g) : "";
            backorderDate = `${bdd}/${bmm}/${byyyy}`;
            setBackOrderDate(backorderDate)
            console.log("minDiscountedPriceWithoutVAT", defaultVariant?.minDiscountedPriceWithoutVAT)
          updatePromotionData({
            promotionDiscountedPrice: defaultVariant?.category?.minDiscountedPrice,
            promotionDiscountedPriceWithoutVAT: defaultVariant?.minDiscountedPriceWithoutVAT,
            promotionEndDate: defaultVariant?.promotionEndDate,
            promotionStartDate: defaultVariant?.promotionStartDate,
            promotionStatus: defaultVariant?.promotionStatus,
            promotionTimer: defaultVariant?.promotionTimer,
            promotionTextAr: defaultVariant?.promotionTextAr?.includes("SAR")
              ? defaultVariant.promotionTextAr.replace(/SAR/g, t("SAR"))
              : defaultVariant?.promotionTextAr,
            promotionTextEn: defaultVariant?.promotionTextEn?.includes("SAR")
              ? defaultVariant.promotionTextEn.replace(/SAR/g, t("SAR"))
              : defaultVariant?.promotionTextEn,
          })

            const images = defaultVariant?.productURLs.map((item: any, index: number) => {
                return {
                    "id": index,
                    "smallImage": `${serverURL}${item.trim()}`,
                    "alt": "DeviceImages",
                    "isRefined": index === 0 ? true : false,
                    "bigImage": `${serverURL}${item.trim()}`
                }
            });

            setDeviceImages(images);
            gtmDataLayer(productCategory);
        }
    }, [hits]);

    useEffect(() => {
        onFindVariation();
    }, [filters])

    useEffect(() => {
        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                journeyName: backOrder ? 'Devices_Back-Order' : preOrder ? 'Devices_Pre-Order' : 'Devices_StandAlone',
                orderType: backOrder ? "Back-order" : preOrder ? "Pre-order" : "Order"
            }
        })
    }, [preOrder, backOrder])

    const gtmDataLayer = (category: any) => {
        const item_cat = category.deviceSubType.valueEn === "Smart Watches" ? "Wearables" : category.deviceSubType.valueEn === 'Smart Phones' ? 'Phones' : category.deviceSubType.valueEn;

        win.dataLayer.push({
            "event": "view_item",
            "ecommerce": {
                "user_id": "",
                "login_type": "not_logged_in",
                "screen_type": "device-page",
                "screen_name": "product_info",
                "language_selected": rtl ? "AR" : "EN",
                "currency": "SAR",
                "items": [{
                    "item_name": category?.name?.valueEn,
                    "item_category": item_cat,
                    "price": category.minPrice,
                    "item_id": seriesId,
                    "item_variants": "",
                    "index": 0,
                    "item_brand": category?.brand?.valueEn,
                    "currency": "SAR",
                    "item_list_name": "Phones and Accessories",
                    "quantity": 1,
                    "Order_type": backOrder ? "Back-order" : preOrder ? "Pre-order" : "Order"
                }],
            }
        });
    }

    const onFindVariation = () => {
        const chosen = getChoosenAttributesCount();

        // Always update enabled attribute states first
        onUpdateAttributes();

        if (chosen === attributes.length) {
            const matches = findMatchingVariations(productVariationData, filters);

            if (matches.length > 0) {
                const product = matches[0];

                setMatchedProduct(product);
                setPrice(product?.price);
                setProductID(product?.id);
                setInitialPrice(false);
                setIsVariantError(false);
                setButtonDisabled(false);

                setPreOrder(product?.preOrder);
                console.log("product", product);
                setBackOrder(product?.backOrder);
                setEligibleTamara(product?.eligibleForTamara);
            console.log("minDiscountedPriceWithoutVAT", product?.minDiscountedPriceWithoutVAT)

              updatePromotionData({
                promotionDiscountedPrice: product?.promotionDiscountedPrice,
                promotionDiscountedPriceWithoutVAT: product?.promotionDiscountedPriceWithoutVAT,
                promotionEndDate: product?.promotionEndDate,
                promotionStartDate: product?.promotionStartDate,
                promotionStatus: product?.promotionStatus,
                promotionTimer: product?.promotionTimer,
                promotionTextAr: product?.promotionTextAr?.includes("SAR")
                  ? product.promotionTextAr.replace(/SAR/g, t("SAR"))
                  : product?.promotionTextAr,
                promotionTextEn: product?.promotionTextEn?.includes("SAR")
                  ? product.promotionTextEn.replace(/SAR/g, t("SAR"))
                  : product?.promotionTextEn,
                })

                const [yyyy, mm, dd] = product?.preOrderDeliveryDate?.split('-') || [];
                setPreOrderDate(dd && mm && yyyy ? `${dd}/${mm}/${yyyy}` : "");

                const [byyyy, bmm, bdd] = product?.backOrderDeliveryDate?.split('-') || [];
                setBackOrderDate(bdd && bmm && byyyy ? `${bdd}/${bmm}/${byyyy}` : "");

                dispatch({ type: "PRODUCT_DATA", payload: { productData: product } });

                const journeyName = product.backOrder ? "Devices_Back-Order" : product.preOrder ? "Devices_Pre-Order" : "Devices_StandAlone";

                setCookie("device-journeyName", journeyName);
                setCookie("device-poid", product.id);

                setOutOfStock(false);
            } else {
                const outOfStockMatch = productVariants.find((variant: any) => {
                    return Object.entries(filters).every(([key, val]) => {
                        if (!val) return true;
                        return rtl ? variant[key]?.valueAr === val : variant[key]?.valueEn === val;
                    });
                });

                if (outOfStockMatch) {
                    console.log("🚫 OUT-OF-STOCK", outOfStockMatch);
                    setOutOfStock(true);
                    setMatchedProduct({});
                    setButtonDisabled(false);
                    setPrice(outOfStockMatch?.price);
                    dispatch({ type: "PRODUCT_DATA", payload: { productData: outOfStockMatch } });
                } else {
                    console.log("❌ NO MATCH FOUND FOR FULL SELECTION:");
                    setOutOfStock(false);
                    setButtonDisabled(true);
                    setMatchedProduct({});
                    dispatch({ type: "PRODUCT_DATA", payload: { productData: {} } });
                }
            }
        } else {
            // PARTIAL SELECTION
            setMatchedProduct({});
            setInitialPrice(true);
            setPrice(productCategory?.minPrice);
            setPreOrder(false);
            setBackOrder(false);
            setPreOrderDate("");
            setBackOrderDate("");
            setButtonDisabled(false);

            dispatch({ type: "PRODUCT_DATA", payload: { productData: {} } });

            setCookie("device-journeyName", "Devices_StandAlone");
            setCookie("device-poid", "");
            setOutOfStock(false);
        }
    };

    const getChoosenAttributesCount = () => {
        let filterCount = 0;
        if (filters) {
            for (let key in filters) {
                if (filters[key] !== "") filterCount++;
            }
        }
        return filterCount;
    };

    const onUpdateAttributes = () => {
        const enabledAttrs: any = {};

        attributes.forEach((attr: any) => {
            const attributeName = attr.name;
            const options = attr.options || [];

            const validOptions = options.filter((opt: any) => {
                // Assume this option is selected
                const testFilters = { ...filters, [attributeName]: opt };

                // See if ANY variation matches this combination
                const matches = findMatchingVariations(productVariationData, testFilters);

                return matches.length > 0;
            });

            enabledAttrs[attributeName] = validOptions;
        });

        setEnabledAttributeOptions(enabledAttrs);
    };

    const findMatchingVariations = (variations: any, attributes: any) => {
        var matching = [];
        for (var i = 0; i < variations.length; i++) {
            var variation = variations[i];

            if (isMatch(variation.attributes, attributes)) {
                matching.push(variation);
            }
        }
        return matching;
    };

    const isMatch = (variation_attributes: any, attributes: any) => {
        var match = true;
        for (var attr_name in variation_attributes) {
            var attribute = variation_attributes[attr_name];
            var val1 = attribute.option;
            var val2 = attributes[attribute.name];
            if (
                val1 !== undefined &&
                val2 !== undefined &&
                val1.length !== 0 &&
                val2.length !== 0 &&
                val1 !== val2
            ) {
                match = false;
            }
        }
        return match;
    };

    const getVariantHandler = (key: string, value: string) => {
        if (key.toLowerCase().includes('color')) {
            updateProductImages(key, value);
        }

        setIsVariantError(false);
        setMissingVariant(false);

        setFilters((prev: any) => {
            const updated = {
                ...prev,
                [key]: prev[key] === value ? "" : value
            };
            return updated;
        });
    };

    const onSelectImg = (data: any) => {
        console.log('Selected Image Data:', data);
    }

    let tooltipTimeout: any;

    const showTooltip = () => {
        tooltipTimeout = setTimeout(() => {
            const tooltipValue = modalRef.current.innerText;

            if (tooltipValue.length > 44) {
                setTooltipVisibility(true);
            } else {
                setTooltipVisibility(false);
            }
        }, 500);
    };

    const hideTooltip = () => {
        clearTimeout(tooltipTimeout);
        setTooltipVisibility(false);
    };

    const callGraphqlApi = (productId: any, flow: string) => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        dispatch({ type: 'PRODUCT_VARIANT_ID', payload: { productId } });

        graphqlApi(productId)
            .then((res: any) => {
                if (res.status === 200 && res?.data?.data.getProductOfferByID) {
                    const responseData = res?.data?.data?.getProductOfferByID[0];
                    dispatch({ type: 'GRAPHQL_RESPONSE_SUCCESS', payload: { graphQlResponse: res?.data?.data } });
                    const category = responseData.category.filter((type: any) => {
                        if (type.name == 'Devices and Accessories') return type
                    })[0];

                    setVeriantId(productId);
                    const skuDetails = responseData?.specCharValueUse?.filter((val: any) => (val.name === 'SKU'))[0];
                    const sId = skuDetails?.specCharacteristicValue[0]?.value ? skuDetails?.specCharacteristicValue[0]?.value : "";
                    setSkuId(sId);

                    if (responseData.stock.warehouseStatus !== 'Out of Stock') {
                        setStockStatus(false);

                        const sc_payload = {
                            productCharacteristic: res?.data?.data?.getProductOfferByID[0].specCharValueUse,
                            productId: productId,
                            category: {
                                id: category.id,
                                name: category.name
                            }
                        }
                        callCreateShoppingApi(sc_payload, flow);
                    } else {
                        dispatch({ type: 'LOADER', payload: { loading: false } })
                        const errCode = res?.status;
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrorCode(errCode);
                        setStockStatus(true);
                    }
                } else if (res.status === 500 && res?.data?.errors?.[0]?.extensions?.code === "UNAUTHENTICATED") {
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    setErrorModal(true)
                    setErrorTitle(t('graphqlErrorTitle1'))
                } else {
                    handleApiError(res, stepName);
                }
            }).catch((err: any) => {
                handleApiError(err, stepName);
            })
    }

    const callCreateShoppingApi = (sc_payload: any, flow: string) => {
        createShoppingcart(sc_payload, journeyName,)
            .then((res: any) => {
                if (res.status === 201 && res.data) {
                    setCookie('device-scId', res.data.id);
                    setCookie('device-xCoId', xCoId);
                    setCookie('device-count', 1);
                    dispatch({ type: 'SET_SHOPPING_CARTID', payload: { cartId: res.data.id } });
                    dispatch({ type: 'SET_SHOPPING_DATA', payload: { scData: res.data } });

                    if (flow === 'subsidy' || flow === 'instalment') {
                      sessionStorage.setItem('device-flow', flow)
                      dispatch({ type: 'LOADER', payload: { loading: false } })
                      dispatch({ type: 'PAGE_TO_DISPLAY', payload: { pageToDisplay: 'Subsidy' } })
                      dispatch({ type: 'DEVICE_FLOW', payload: { deviceFlow: flow } })
                    } else {
                      const price=promotion?.promotionDiscountedPrice;                      
                      if(isPromotionActive && price && price !== 0){
                         promotionQualification(res.data, 'Anonymous')
                        .then((res: any) => {
                          if (res.status === 200 && res.data) {
                            const cart = res.data.cart
                            const offerContainer = cart.offerContainer?.[0]
                            const offerContainerItem = offerContainer?.offerContainerItem?.[0]
                            const promotion = offerContainerItem?.promotions?.default?.[0]
                            const action = promotion?.action?.[0]
                            const req = {
                              shoppingCartData: {
                                scId: cart?.id || '',
                                ocId: offerContainer?.id || '',
                              },
                              promotionData: {
                                promotionId: promotion?.id || '',
                                signature: promotion?.signature || '',
                                actionObjectId: action?.actionObjectId || '',
                                actionValue: action?.actionValue || 0,
                              },
                            }

                            applyPromotion(req.shoppingCartData, req.promotionData)
                              .then((res: any) => {
                                if (res.status === 200 && res.data) {
                                  window.location.href = `${serverURL}${cartPage}`
                                } else {
                                  const config = Object.assign(res?.config, {
                                    serviceName: 'applyPromotion',
                                  })
                                  const response = { ...res, config }
                                  dispatch({ type: 'LOADER', payload: { loading: false } })
                                  handleApiError(response, stepName)
                                }
                              })
                              .catch(err => {
                                const config = Object.assign(err?.config, {
                                  serviceName: 'applyPromotion',
                                })
                                const error = { ...err, config }
                                handleApiError(error, stepName)
                              })
                          } else {
                            dispatch({ type: 'LOADER', payload: { loading: false } })
                            handleApiError(res, stepName)
                          }
                        })
                        .catch(err => {
                          handleApiError(err, stepName)
                        })
                      } else{
                         window.location.href = `${serverURL}${cartPage}`
                      }
                     
                    }

                } else if (res.status === 429) {
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    const errCode = res?.status;
                    setTransId(res?.config?.headers['X-Transaction-Id']);
                    setErrorCode(errCode);
                    setThrottleFlag(true)
                } else if (res?.status === 200 && res?.data?.code === '404') {
                    const enMessage = res?.data?.message ? res?.data?.message : "";
                    const arMessage = res?.data?.messageAr ? res?.data?.messageAr : "";
                    const errMessage = rtl ? arMessage : enMessage;

                    setAvailabilityMsg(errMessage);
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    const errCode = res?.status;
                    setTransId(res?.config?.headers['X-Transaction-Id']);
                    setErrorCode(errCode);
                    setAvailabilityFlag(true)
                } else if (res?.status === 400 && res?.data?.code === 'BMCOM_SC_40001') {
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    setErrorTitle(t("shopingCartErrorTitle"))
                    setErrorModal(true)
                } else if (res?.status === 504) {
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                    setIsServiceError(true)
                }
                else {
                    const config = Object.assign(res?.config, { serviceName: 'createShoppingCart' });
                    const response = { ...res, config }
                    handleApiError(response, stepName);
                }
            }).catch((err: any) => {
                const config = Object.assign(err?.config, { serviceName: 'createShoppingCart' });
                const error = { ...err, config }

                if (error?.response?.status) {
                    handleApiError(error, stepName);
                } else {
                    ++createshoppingcartCounter
                    if (createshoppingcartCounter < retryCount) {
                        callCreateShoppingApi(sc_payload, subsidyFlow);
                    } else {
                        handleApiError(error, stepName);
                    }
                }
            })
    }

    const handleAddCart = (flow: string) => {
        setSubsidyFlow(flow);

        const pId = new URL(window.location.href).searchParams.get('vId');
        const dataArray = Object.entries(filters).map(([name, value]) => ({ name, value }));

        if (pId) {
            callingShoppingCart(pId, flow)
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

            if (outOfStock) {
                console.log('outOfStock', outOfStock);
                setNotifyMeFlow(true);
            } else {
                setNotifyMeFlow(false);
                const newArray = [];
                for (const key in filters) {
                    if (Object.prototype.hasOwnProperty.call(filters, key)) {
                        if (filters[key] !== "") {
                            newArray.push(filters[key]);
                        }
                    }
                }
                if (dataArray.length > 0 && (dataArray.length === newArray.length)) {
                    callingShoppingCart(productID, flow)
                } else {
                    setMissingVariant(true);
                    setIsVariantError(true)
                }
            }
        }
    }

    const callingShoppingCart = (pr_id: any, flow: string) => {
        const shoppingCartID = checkCookie('device-scId');
        const item_cat = productCategory?.deviceSubType.valueEn === "Smart Watches" ? "Wearables" : productCategory?.deviceSubType.valueEn === 'Smart Phones' ? 'Phones' : productCategory?.deviceSubType.valueEn;

        const gtmObj = {
            "event": "add_to_cart",
            "ecommerce": {
                "user_id": "",
                "login_type": "not_logged_in",
                "screen_type": "device-page",
                "screen_name": "product_info",
                "language_selected": rtl ? "AR" : "EN",
                "currency": "SAR",
                "value": "",
                "tax": "15% vat",
                "items": [{
                    "item_name": productCategory?.name?.valueEn,
                    "item_category": item_cat,
                    "price": matchedProduct?.price,
                    "apple_care": "no",
                    "item_id": seriesId,
                    "item_variants": matchedProduct?.id,
                    "index": 0,
                    "item_brand": productCategory?.brand?.valueEn,
                    "currency": "SAR",
                    "item_list_name": "Phones and Accessories",
                    "quantity": 1,
                    "discount": "",
                    "discount_type": "",
                    "Order_type": orderType
                }],
            }
        }
        if (flow === 'cart')
            try {
                win.MixpanelTracker.trackEvent("Product Added to Cart", {
                    product_category: productCategory?.deviceSubType?.code,
                    product_name: matchedProduct?.name?.valueEn,
                    product_price: matchedProduct?.price,
                    product_brand: productCategory?.brand?.code,
                })
            } catch (e) {
                console.log("Mixpanel Error:", e);
            }

        const foundIndex = win.dataLayer.findIndex((x: any) => x.event == gtmObj.event);
        if (foundIndex >= 0) {
            win.dataLayer[foundIndex] = gtmObj;
        } else {
            win.dataLayer.push(gtmObj);
        }

        if (shoppingCartID) {
            window.scroll({ top: 0, left: 0, behavior: "smooth" });
            setCartFull(true);
        } else {
            setCartFull(false);
            callGraphqlApi(pr_id, flow);
        }
    }

    const handleModalReplace = () => {
        document.body.style.overflow = 'auto';
        const pId = new URL(window.location.href).searchParams.get('vId');
        setCartFull(false);
        if (pId) {
            callGraphqlApi(pId, subsidyFlow);
        } else {
            callGraphqlApi(productID, subsidyFlow);
        }
    }

    const handleModalCancel = () => {
        setCartFull(false);
        document.body.style.overflow = 'auto'
    }

    const handleStockStatus = () => {
        setStockStatus(false);
        document.body.style.overflow = 'auto';
    }

    const handleMissingVariant = () => {
        setMissingVariant(false);
        document.body.style.overflow = 'auto';
    }

    const updateProductImages = (key: string, info: any) => {
        const product = productVariants.filter((pr: any) => {
            if (rtl) {
                return pr[key].valueAr === info
            } else {
                return pr[key].valueEn === info
            }
        });
        const deviceImg = product[0].productURLs.map((item: any, index: number) => {
            return ({
                "id": index,
                "smallImage": `${serverURL}${item.trim()}`,
                "alt": "DeviceImages",
                "isRefined": index === 0 ? true : false,
                "bigImage": `${serverURL}${item.trim()}`
            })
        });
        setDeviceImages(deviceImg);
    }

    const getImgModal = () => {
        setModalVisable(true)
    }

    const redirectToTradeIn = () => {
        window.open(deviceTradeLink, '_blank');
    }

    const onClickZoom = () => {
        setImgZoomIn(!imgZoomIn)
    }

    const handleThrottling = () => {
        document.body.style.overflow = 'auto';
        setThrottleFlag(false)
    }

    const handleAvailability = () => {
        document.body.style.overflow = 'auto';
        setAvailabilityFlag(false)
    }
    const fixedPreorderSeriesIds = [
        "galaxy_z_flip7_series_da_20250707",
        "galaxy_z_fold7_fe_series_da_20250707",
        "galaxy_z_fold7_series_da_20250707",
    ];

    const handleGraphqlError = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setErrorModal(false);
        document.body.style.overflow = 'auto';
        window.location.reload();
    }

    const handleServiceError = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setIsServiceError(false);
        document.body.style.overflow = 'auto';
        window.location.href = homePageUrl
    }

      const now =  currentTime;
  // console.log("Current Time:", new Date(now).toLocaleString());

  const isPromotionActive =
    promotion?.promotionStatus === "Active" &&
    now >= new Date(promotion?.promotionStartDate).getTime() 
    &&
    now < new Date(promotion?.promotionEndDate).getTime();
  const offerBadge = isPromotionActive
    ? (rtl ? promotion?.promotionTextAr : promotion?.promotionTextEn)
    : "";
   
  const offerTimer =
    isPromotionActive && promotion?.promotionTimer
      ? `${t("Offer_Ends_In")} ${getRemainingTime(
          promotion?.promotionEndDate,
          currentTime
        )}`
      : "";

    const prodTamaraURL = `https://cdn.tamara.co/widget-v2/tamara-widget.html?lang=${lang}&public_key=006d10cc-9566-459a-be08-042ed9599f4a&country=SA&amount=${price?.length === 0 ? productCategory?.minPrice : price}&inline_type=2`;
    const lowerTamaraURL = `https://cdn-sandbox.tamara.co/widget-v2/tamara-widget.html?lang=${lang}&public_key=c7b0077d-f0b2-4bef-b376-af54456eda37&country=SA&amount=${price?.length === 0 ? productCategory?.minPrice : price}&inline_type=2`;
    return (
      <>
        {notifyMeFlow ? (
          <NotifyMe />
        ) : (
          <>
            <div className="TransactionID" id="TransactionID" style={{ display: 'none' }}>
              {transId}
            </div>
            <div className="ErrorCode" id="ErrorCode" style={{ display: 'none' }}>
              {errorCode}
            </div>
            <div id="ecommerceJourneyName" style={{ display: 'none' }}>
              {journeyName}
            </div>
            <div id="xCorrelationId" style={{ display: 'none' }}>
              {xCoId}
            </div>
            <div id="sectionId" style={{ display: 'none' }}>
              ProductDetails
            </div>
            <div id="DeviceName" style={{ display: 'none' }}>
              {poid}
            </div>
            <div id="DeviceVeriantId" style={{ display: 'none' }}>
              {veriantId}
            </div>
            <div id="SkuId" style={{ display: 'none' }}>
              {skuId}
            </div>

            <div
              className={
                rtl
                  ? 'deviceDetails__container container deviceDetails__Right'
                  : 'deviceDetails__container container'
              }
            >
              <ConfirmModal
                id="modal-devices"
                showModal={modalVisable}
                onClickClose={() => {
                  setModalVisable(false)
                }}
              >
                <div
                  className={`popup_device_images ${imgZoomIn === true ? 'zoomIn_img' : 'zoomOut_img'}`}
                >
                  <DeviceImages
                    id="devices-images"
                    onClick={onSelectImg}
                    VisibleArrowLeft={false}
                    VisibleArrowRight={true}
                    bigImage={serverURL + productCategory?.defaultURL}
                    data={deviceImages}
                    onClickimgModal={onClickZoom}
                  />
                </div>
              </ConfirmModal>

              {productVariants.length > 0 && (
                <>
                  {scrollY > 100 ? (
                    <div className="DD__TitleScroll">
                      <Typography
                        id="brand-name"
                        rtl={rtl}
                        className="scrollTitle devices-container"
                      >
                        {rtl
                          ? `${productCategory?.brand?.valueAr} ${productCategory?.name?.valueAr}`
                          : `${productCategory?.brand?.valueEn} ${productCategory?.name?.valueEn}`}
                      </Typography>
                    </div>
                  ) : (
                    <div className="DD__Title">
                     
                      <Typography id="brand-name" rtl={rtl} className="brandNameNew">
                        {rtl ? productCategory?.brand?.valueAr : productCategory?.brand?.valueEn}
                      </Typography>
                      <div
                        className="tooltip-container"
                        onMouseEnter={showTooltip}
                        onMouseLeave={hideTooltip}
                      >
                        <div id="brand-name" ref={modalRef} className="modalName">
                          {rtl ? productCategory?.name?.valueAr : productCategory?.name?.valueEn}
                        </div>
                        {isTooltipVisible && (
                          <Typography id="brand-types" rtl={rtl} className="custom-tooltip">
                            {rtl ? productCategory?.name?.valueAr : productCategory?.name?.valueEn}
                          </Typography>
                        )}
                      </div>
                      <Typography id="starting-prices" rtl={rtl} className="modalPrice">
                        {t('starting_from')} {t('SAR')} {isPromotionActive && productCategory?.minDiscountedPriceWithoutVAT > 0 ? productCategory?.minDiscountedPriceWithoutVAT : productCategory?.minPriceWithoutVAT}{' '}
                    {   isPromotionActive && productCategory?.minDiscountedPriceWithoutVAT > 0 && <span>{productCategory?.minPriceWithoutVAT}</span>}
                      </Typography>
                      <div className="deviceOfferContainerpdp">
                        {offerBadge && <div className="deviceOfferBadgepdp">{offerBadge}</div>}
                         {!backOrder && preOrder && (
                        <div className="preOrder_container">
                          <Typography id="pre-order" rtl={rtl} className="preOrder_text">
                            {t('pre_order')}
                          </Typography>
                        </div>
                       )} 
                        {offerTimer && <div className="offerTimerpdp">{offerTimer}</div>}
                      </div>
                      {!backOrder && preOrder && (
                        <Typography id="pre-order" rtl={rtl} className="preOrder_text">
                          {`${t('For_pre_order')} ${preOrderDate}`}
                        </Typography>
                      )}
                      {backOrder && (
                        <Typography id="pre-order" rtl={rtl} className="preOrder_text">
                          {`${t('Expected_Delivery')} ${backOrderDate}`}
                        </Typography>
                      )}
                      {soldOut && (
                        <Typography id="out-of-stock" rtl={rtl} className="soldOut_text">
                          {t('Item_out_of_Stock')}
                        </Typography>
                      )}
                    </div>
                  )}

                  <div id="devices-details" className="deviceDetails__subcontainer">
                    <div className="half">
                      <div
                        id="devices-images"
                        className={
                          scrollY > 100
                            ? 'productImgContainer productImg__Scroll'
                            : 'productImgContainer'
                        }
                      >
                        <DeviceImages
                          onClick={onSelectImg}
                          VisibleArrowLeft={false}
                          VisibleArrowRight={true}
                          bigImage={serverURL + productCategory?.defaultURL}
                          data={deviceImages}
                          onClickimgModal={getImgModal}
                        />
                      </div>
                    </div>
                    <div className="gap" />
                    <div className="half">
                      <div
                        id="device-variants"
                        className={
                          scrollY > 100
                            ? 'deviceVariants__container DVC__Scroll'
                            : 'deviceVariants__container'
                        }
                      >
                        {eligibleTamara && (
                          <a
                            href={
                              win['env_variable']?.toUpperCase() === PROD
                                ? prodTamaraURL
                                : lowerTamaraURL
                            }
                            target="_blank"
                          >
                            <div
                              id="tamara-payment-card"
                              className={`tamara_payment_card ${rtl ? 'pl-3' : 'pr-3'}`}
                            >
                              <div className="card_content">
                                <div className="card_text_section">
                                  <img
                                    className="Tamara__Image"
                                    src={rtl ? TamarabadgeAR : TamarabadgeEN}
                                    alt="TamarabadgeEN"
                                    width={62}
                                    height={24}
                                  />
                                  <div className="desktop-text">
                                    <Typography rtl={rtl} className="device_tradeIn_title">
                                      {t('split_cost_smaller_payment')}
                                    </Typography>
                                    <Typography rtl={rtl} className="device_tradeIn_subTitle">
                                      {t('no_interest_no_hidden')}
                                    </Typography>
                                  </div>
                                  <div className="mobile-text">
                                    <Typography rtl={rtl} className="device_tradeIn_title">
                                      {t('split_cost_smaller_payment_mobile')}
                                    </Typography>
                                    <Typography rtl={rtl} className="device_tradeIn_subTitle">
                                      {t('no_interest_no_hidden_mobile')}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="device_tradeIn_new_container">
                                  <Typography className="device_tradeIn_new">{t('new')}</Typography>
                                </div>
                              </div>
                            </div>
                          </a>
                        )}

                        {appleCareBanner && <AppleCare rtl={rtl} />}

                        {tradeInEnabled === 'true' && (
                          <div
                            id="device-tradeIn"
                            className={`tamara_payment_card ${rtl ? 'pl-3' : 'pr-3'}`}
                          >
                            <div className="tamara_seperator"></div>
                            <div className="card_content">
                              <div className="card_text_section">
                                <img
                                  className="Tamara__Image"
                                  src={rtl ? tradeinOrg : tradeinOrg}
                                  alt="DeviceEN"
                                  width={60}
                                  height={65}
                                />
                                <div className="desktop-text">
                                  <Typography rtl={rtl} className="device_tradeIn_title">
                                    {t('device_trade_in')}
                                  </Typography>
                                  <Typography rtl={rtl} className="device_tradeIn_subTitle">
                                    {t('trade_existing_phone')}
                                  </Typography>
                                  <div className="device_tradeIn_link" onClick={redirectToTradeIn}>
                                    <Typography rtl={rtl}>{t('get_started')} </Typography>
                                    <div className="circle_arrow_container">
                                      <img
                                        className={`circle_arrow circle_arrow_${rtl ? 'right' : ''}`}
                                        src={CircleArrowRight}
                                        alt="image"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="mobile-text">
                                  <Typography rtl={rtl} className="device_tradeIn_title">
                                    {t('device_trade_in')}
                                  </Typography>
                                  <Typography rtl={rtl} className="device_tradeIn_subTitle">
                                    {t('trade_existing_phone')}
                                  </Typography>
                                  <div className="device_tradeIn_link" onClick={redirectToTradeIn}>
                                    <Typography rtl={rtl}>{t('get_started')} </Typography>
                                    <div className="circle_arrow_container">
                                      <img
                                        className={`circle_arrow circle_arrow_${rtl ? 'right' : ''}`}
                                        src={CircleArrowRight}
                                        alt="image"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="device_tradeIn_new_container">
                                <Typography className="device_tradeIn_new">{t('new')}</Typography>
                              </div>
                            </div>
                          </div>
                        )}

                        <div
                          id="device-tradeIn"
                          className={`tamara_payment_card ${rtl ? 'pl-3' : 'pr-3'}`}
                        >
                          <div className="tamara_seperator"></div>
                        </div>

                        {isAppleDevice && <div className="device_appleImageBanner" />}

                        {attributes.map((attribute: any) => {
                          return (
                            <ProductVariants
                              key={attribute.id}
                              selectedButtons={filters}
                              attributeId={attribute.id}
                              isVariantError={isVariantError}
                              attributeName={attribute.name}
                              getVariantHandler={getVariantHandler}
                              attributeOptions={attribute?.options?.filter((item: any) => item)}
                              optionColors={attribute.hex_options}
                              enabledAttributeOptions={enabledAttributeOptions}
                            />
                          )
                        })}
                      </div>
                      {/* {(preOrder && matchedProduct?.category?.deviceSubType?.valueEn.toLowerCase() !== 'accessories') && (
                                    <AppleCare rtl={rtl} />
                                )} */}
                      {(matchedProduct?.eligibleSubsidy ||
                        matchedProduct?.eligibleForInstallment ||
                        (preOrder && fixedPreorderSeriesIds.includes(seriesId))) && (
                        <ProductFinance
                          rtl={rtl}
                          handleAddCart={handleAddCart}
                          subsidyFlag={matchedProduct?.eligibleSubsidy}
                          instalmentFlag={matchedProduct?.eligibleForInstallment}
                          preOrderInstallmentFlag={
                            preOrder && fixedPreorderSeriesIds.includes(seriesId)
                          }
                        />
                      )}
                    </div>
                  </div>

                  <StickyPriceBar
                    rtl={rtl}
                    id="sticky-price"
                    priceId="total-price"
                    buttonId={soldOut ? 'notify-me' : 'add-to-cart'}
                    buttonDisabled={buttonDisabled}
                    priceTitle={initialPrice ? t('starting_from') : ''}
                    offerPrice={isPromotionActive && promotion.promotionDiscountedPrice > 0 ? (price?.length === 0 ? productCategory?.minPrice : price) : ''}
                    price={`${t('SAR')} ${isPromotionActive && promotion.promotionDiscountedPrice > 0 ? promotion.promotionDiscountedPrice : (price?.length === 0 ? productCategory?.minPrice : price)}`}
                    currencyType={''}
                    vat={t('Incl_Vat')}
                    buttonValue={soldOut || outOfStock ? t('Notify_me') : t('Add_to_cart')}
                    onClick={() => handleAddCart('cart')}
                  />
                </>
              )}

              {cartFull && (
                <ErrorModal
                  id="duplicate-shopping-cartId"
                  rtl={rtl}
                  title={t('Your_Cart_Full')}
                  description={t('One_Item_At_Moment')}
                  firstButtonText={t('Replace_Cart')}
                  secButtonText={t('Cancel')}
                  modalFirstButtonClick={handleModalReplace}
                  modalSecondButtonClick={handleModalCancel}
                />
              )}

              {stockStatus && (
                <ErrorModal
                  id="error-out-of-stock"
                  rtl={rtl}
                  title={t('Item_Sold_Out')}
                  description={t('Combination_Out_of_Stock')}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleStockStatus}
                />
              )}

              {throttleFlag && (
                <ErrorModal
                  id="error-throttle"
                  rtl={rtl}
                  title={t('High_Order_Demand')}
                  description={t('')}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleThrottling}
                />
              )}

              {availabilityFlag && (
                <ErrorModal
                  id="error-availability"
                  rtl={rtl}
                  title={availabilityMsg}
                  description={t('')}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleAvailability}
                />
              )}

              {missingVariant && (
                <ErrorModal
                  id="error-select-variant"
                  rtl={rtl}
                  title={t('select_all_specs')}
                  description={t('')}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleMissingVariant}
                />
              )}

              {errorModal && (
                <ErrorModal
                  id="error-select-variant"
                  rtl={rtl}
                  title={errorTitle}
                  description={t('')}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleGraphqlError}
                />
              )}

              {isServiceError && (
                <ErrorModal
                  id={'service_busy_error_handling'}
                  className="Error__Modal_updated"
                  rtl={rtl}
                  title={t('Some_of_our_services_are_busy')}
                  description={''}
                  firstButtonText={t('Got_it')}
                  modalFirstButtonClick={handleServiceError}
                />
              )}
            </div>
          </>
        )}
      </>
    )
}

export default ProductDetails;